import React from 'react'
import { Text, Hide, Flex, Stamp } from 'pcln-design-system'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Discount } from 'pcln-icons'

const LabelText = styled(Text.span)`
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
`

const ExpressDealDescription = ({ budgetSaver, ...props }) => (
  <Text {...props} color='success.base' fontSize={0}>
    <Flex alignItems={'center'}>
      <Stamp color='success.base' mr={[2, 2, 3, 3]} style={{ whiteSpace: 'nowrap' }}>
        <Discount size={'14px'} mr={1} />
        <LabelText color='success.base'>Budget Friendly</LabelText>
      </Stamp>

      <Hide md lg xl xxl>
        {budgetSaver.shortCopy}
      </Hide>

      <Hide xs sm>
        {budgetSaver.longCopy}
      </Hide>
    </Flex>
  </Text>
)

ExpressDealDescription.defaultProps = {
  budgetSaver: {},
}

ExpressDealDescription.propTypes = {
  vipSavingsPercent: PropTypes.string,
  signInPrompt: PropTypes.bool,
  enableExpressDealVip: PropTypes.bool,
  vipTier: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isMobile: PropTypes.bool,
  budgetSaver: PropTypes.shape({
    longCopy: PropTypes.string,
    shortCopy: PropTypes.string,
    tag: PropTypes.string,
  }),
}

export { ExpressDealDescription }
